import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, organizationCategory, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        organizationCategory === 'Improvement Service' ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard/notFound",
              //state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;

